import {ClassJsonFetch} from 'Class'
import { TypePublicEnv } from 'Type'

class ClassPublicEnv extends ClassJsonFetch<TypePublicEnv> {
    constructor() {
        super('/env.json');
    }
}

export default new ClassPublicEnv()